module.exports = __webpack_public_path__ + "static/media/bilista_horizontal.bd843a99.svg";